export const I18n = window.I18n;
export const currentUser = window.currentUser;
